import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'app/rootReducer'
import CustomModal from 'components/organisms/CustomModal'
import { getActiveDiscInstUrlInfo } from 'reducers/activecourse/activecourseSlice'

interface CourseViewInstructionsModalProps {
  show: boolean
  onHide: () => void
}

const CourseViewInstructionsModal = (
  props: CourseViewInstructionsModalProps
): JSX.Element => {
  const [title, setTitle] = useState('')
  const [instructions, setInstructions] = useState('')
  const activeCourse = useSelector((state: RootState) => state.activeCourse)
  const discInstUrlInfo = useSelector(getActiveDiscInstUrlInfo)

  useEffect(() => {
    if (activeCourse && activeCourse.activeTab) {
      if (activeCourse.activeTab === 'first') {
        setTitle('First Course Instructions')
      } else {
        setTitle('Second Course Instructions')
      }
    }
  }, [activeCourse])

  useEffect(() => {
    if (discInstUrlInfo) {
      setInstructions(discInstUrlInfo.instructions)
    }
  }, [discInstUrlInfo])

  return (
    <CustomModal
      show={props.show}
      showClose={true}
      showFooter={true}
      onHide={props.onHide}
      title={title}
      footerButtons={[
        {
          text: 'Close',
          onClick: props.onHide,
          variant: 'secondary',
          testid: 'course-view-instructions-modal-close-button'
        }
      ]}
    >
      <div>
        <div
          data-testid='course-view-instructions-modal-content'
          dangerouslySetInnerHTML={{
            __html: instructions
          }}
        />
      </div>
    </CustomModal>
  )
}

export default CourseViewInstructionsModal
